// Tiny DOM + grid helpers (no framework).

export const idx = (r: number, c: number): number => r * 9 + c;

type Props = Record<string, unknown>;

/** Create an element. Special props: class, text, html, dataset, on<Event>. */
export function h(tag: string, props: Props = {}, children: Array<Node | string> = []): HTMLElement {
  const e = document.createElement(tag);
  for (const [k, v] of Object.entries(props)) {
    if (v == null) continue;
    if (k === "class") e.className = String(v);
    else if (k === "text") e.textContent = String(v);
    else if (k === "html") e.innerHTML = String(v);
    else if (k === "dataset") Object.assign(e.dataset, v as Record<string, string>);
    else if (k.startsWith("on") && typeof v === "function") {
      e.addEventListener(k.slice(2).toLowerCase(), v as EventListener);
    } else e.setAttribute(k, String(v));
  }
  for (const c of children) e.append(c);
  return e;
}

/** Peers (same row, column, or 3×3 box, excluding the cell itself) for each index. */
const PEERS: number[][] = (() => {
  const out: number[][] = [];
  for (let i = 0; i < 81; i++) {
    const r = Math.floor(i / 9);
    const c = i % 9;
    const set = new Set<number>();
    for (let k = 0; k < 9; k++) {
      set.add(r * 9 + k);
      set.add(k * 9 + c);
    }
    const br = Math.floor(r / 3) * 3;
    const bc = Math.floor(c / 3) * 3;
    for (let dr = 0; dr < 3; dr++)
      for (let dc = 0; dc < 3; dc++) set.add((br + dr) * 9 + (bc + dc));
    set.delete(i);
    out.push([...set]);
  }
  return out;
})();

export const peers = (i: number): number[] => PEERS[i];
